import { render, staticRenderFns } from "./TeamMembersTable.vue?vue&type=template&id=a13a9a54&scoped=true"
import script from "./TeamMembersTable.vue?vue&type=script&lang=js"
export * from "./TeamMembersTable.vue?vue&type=script&lang=js"
import style0 from "./TeamMembersTable.vue?vue&type=style&index=0&id=a13a9a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13a9a54",
  null
  
)

export default component.exports